module.exports = __webpack_public_path__ + "static/appiumLogo-37933c349b59a7cdc432b2b55868638f.png";